import { render } from "./AppSubmenu.vue?vue&type=template&id=110903f7"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/AppSubmenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "110903f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('110903f7', __exports__)) {
    api.reload('110903f7', __exports__)
  }
  
  module.hot.accept("./AppSubmenu.vue?vue&type=template&id=110903f7", () => {
    api.rerender('110903f7', render)
  })

}


export default __exports__